import { Skeleton, IconButton } from "@chakra-ui/react"
import { useEffect, useState } from "react"
import SuggestionPill from "./suggestion-pill"
import { useAppSelector } from "src/redux/hooks";
import { getSelectedInstances } from "src/redux/providerBuilder/selectedInstances/selectors";
import { MinusIcon, AddIcon } from "@chakra-ui/icons"
import { getSelectedNetworkRequest } from "src/redux/providerBuilder/selectedNetworkRequest/selectors"


const SuggestionsList = ({ 
  dataPoints, 
  isLoading, 
  handleAcceptSuggestion, 
  openModalId,
  setOpenModalId 
}: { 
  dataPoints: any[], 
  isLoading: boolean, 
  handleAcceptSuggestion: (data: any) => void,
  openModalId: string | null,
  setOpenModalId: (id: string | null) => void
}) => {
  const [showAll, setShowAll] = useState(false)
  const selectedInstances = useAppSelector(getSelectedInstances);
  const selectedRequests:any = useAppSelector(getSelectedNetworkRequest);

  const displayedItems = showAll ? dataPoints : dataPoints.slice(0, 10)
  const hasMoreItems = dataPoints.length > 10

  const getRequestIndex = (url: string) => {
    return selectedRequests.findIndex((request:any) => request.url === url);
  };

  const isValueAlreadySelected = (value: string, url: string) => {
    const requestIndex = getRequestIndex(url);
    return selectedInstances.some((instance:any) => 
      instance.responseSelection.responseMatch === value && 
      instance.responseSelection.requestIndex === requestIndex
    );
  };

  return (
    <div className="flex flex-wrap gap-2">
      {!isLoading && displayedItems.length > 0 ? (
        <>
          {displayedItems.map((item) => (
            <SuggestionPill 
              key={`${item.responseMatch}-${item.requestUrl}`}
              data={item} 
              isOpen={openModalId === `${item.responseMatch}-${item.requestUrl}`}
              onOpenChange={(open) => setOpenModalId(open ? `${item.responseMatch}-${item.requestUrl}` : null)}
              handleAcceptSuggestion={handleAcceptSuggestion} 
              disabled={isValueAlreadySelected(item.responseMatch, item.requestUrl)}
              isLoading={isLoading}
            />
          ))}
          {hasMoreItems && (
            <IconButton
              aria-label={showAll ? "Show less" : "Show more"}
              icon={showAll ? <MinusIcon /> : <AddIcon />}
              onClick={() => setShowAll(!showAll)}
              variant="outline"
              size="md"
              borderRadius="full"
            />
          )}
        </>
      ) : !isLoading ? (
        <div>No items to display</div>
      ) : (
        <div className="flex flex-wrap gap-2">
          {[...Array(11)].map((_, index) => (
            <Skeleton key={index} height="40px" width="100px" borderRadius="full" />
          ))}
        </div>
      )}
    </div>
  )
}

export default SuggestionsList